const navigation = (template) => ({
  mainContainer: null,
  mainContainerWidth: null,
  showMegaMenu: false,
  selectedHandle: null,
  selectedItem: null,
  showMobileMenu: false,
  showMobileCurrencyDrawer: false,
  selectedMobileHandle: null,
  showSubMenu: false,
  showThirdLevelSubMenu: false,
  body: null,
  selectedThirdLevelMobileHandle: null,
  menuInner: null,
  headerHeight: null,
  announcementBar: null,
  announcementBarHeight: "0px",
  headerGroup: null,
  headerGroupHeight: null,
  scrollUp: "",
  scrollDown: "",
  lastScroll: 0,
  topPosition: 0,
  megaMenuOverlay: null,
  mobileMenuWrapper: null,
  mobileOverlay: null,
  mobileMenuBottomPanel: null,
  pageTemplate: null,
  backgroundIsTransparent: true,
  navigationItems: null,
  isPageHeaderTransparent: "false",
  stickyFilter: null,
  searchResultsContainer: null,
  headerFixed: null,
  isScrolled: false,
  resizeObserver: null,
  lastMenuTrigger: null,
  suppressMenuOpen: false,
  _onKeydown: null,
  updateScrollState(currentScroll) {
    // Keep initial-load state consistent with scroll behavior.
    this.isScrolled = currentScroll > 0

    if (
      this.pageTemplate === "index" ||
      this.pageTemplate === "collection" ||
      this.pageTemplate === "article" ||
      this.isPageHeaderTransparent === "true"
    ) {
      this.backgroundIsTransparent = currentScroll <= 0
    }

    if (currentScroll === 0) {
      this.body.classList.remove(this.scrollDown)
      this.body.classList.remove(this.scrollUp)
    } else if (
      currentScroll > this.lastScroll &&
      !this.body.classList.contains(this.scrollDown)
    ) {
      this.body.classList.remove(this.scrollUp)
      this.body.classList.add(this.scrollDown)
    } else if (
      currentScroll < this.lastScroll &&
      this.body.classList.contains(this.scrollDown)
    ) {
      this.body.classList.remove(this.scrollDown)
      this.body.classList.add(this.scrollUp)
    }

    this.lastScroll = currentScroll
  },
  init() {
    this.mainContainer = document.querySelector("main")
    this.stickyFilter = document.querySelector(".sticky_filter")
    this.pageTemplate = this.mainContainer.getAttribute("data-template")
    this.announcementBar = document.querySelector(".announcement-bar")
    this.headerGroup = document.querySelector(".header-group")
    this.isPageHeaderTransparent =
      this.$el.getAttribute("data-header-transparent") ||
      (this.headerGroup && this.headerGroup.getAttribute("data-transparent")) ||
      "false"
    this.scrollUp = "scroll-up"
    this.scrollDown = "scroll-down"
    this.megaMenuOverlay = document.querySelector(".megamenu-overlay")
    this.mobileMenuWrapper = document.querySelectorAll(".mobile-menu__wrapper")
    this.mobileOverlay = document.querySelector(".mobile-overlay")
    this.mobileMenuBottomPanel = document.querySelector(
      ".mobile-menu__bottom-panel"
    )
    this.searchResultsContainer = document.querySelector(".search-suggestions")
    this.navigationItems = document.querySelectorAll(".navigation-item")
    this.headerFixed = document.querySelectorAll(".header-group-fixed")

    this.setTopPositionForSticky()

    this.resizeObserver = new ResizeObserver(() => {
      this.setTopPositionForSticky()
    })
    if (this.headerGroup) this.resizeObserver.observe(this.headerGroup)
    if (this.announcementBar) this.resizeObserver.observe(this.announcementBar)

    this.body = document.querySelector("html body")
    this.menuInner = document.querySelectorAll(".menu-inner")
    this.updateScrollState(window.pageYOffset)
    this.calculateHeaderWidth()
    window.addEventListener("resize", () => {
      this.setTopPositionForSticky()
      this.calculateHeaderWidth()
    })
    window.addEventListener("scroll", () => {
      const currentScroll = window.pageYOffset
      this.updateScrollState(currentScroll)
      this.calculateHeaderWidth()
    })

    this._onKeydown = (event) => {
      if (event.key !== "Escape") return

      if (this.showMobileCurrencyDrawer) {
        this.closeMobileCurrencyDrawer()
        return
      }

      if (this.showMobileMenu) {
        this.closeMobileMenu()
        return
      }

      if (this.showMegaMenu) {
        this.closeMegaMenuAndRestoreFocus()
      }
    }
    window.addEventListener("keydown", this._onKeydown)
  },
  destroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
      this.resizeObserver = null
    }
    if (this._onKeydown) {
      window.removeEventListener("keydown", this._onKeydown)
      this._onKeydown = null
    }
  },
  getNavItemEl(event) {
    return event.currentTarget || event.target
  },
  closeMegaMenuAndRestoreFocus() {
    const trigger = this.lastMenuTrigger
    // Returning focus to the trigger re-fires focusin, which would reopen the menu.
    this.suppressMenuOpen = true
    this.closeMegaMenu()
    if (trigger && typeof trigger.focus === "function") {
      trigger.focus()
    }
    this.lastMenuTrigger = null
    requestAnimationFrame(() => {
      this.suppressMenuOpen = false
    })
  },
  handleNavFocusOut(event) {
    const itemEl = this.getNavItemEl(event)
    if (!itemEl || typeof itemEl.contains !== "function") return

    requestAnimationFrame(() => {
      if (!this.showMegaMenu) return
      // Another nav item already took over on the same tab press.
      if (this.selectedItem && this.selectedItem !== itemEl) return
      if (itemEl.contains(document.activeElement)) return

      this.closeMegaMenu()
      this.lastMenuTrigger = null
    })
  },
  setTopPositionForSticky() {
    if (this.announcementBar) {
      this.announcementBarHeight = this.announcementBar
        ? this.announcementBar.offsetHeight
        : 0
      this.announcementBarHeight = this.announcementBarHeight + "px"
    }
    if (this.headerGroup) {
      this.headerGroupHeight = this.headerGroup
        ? this.headerGroup.offsetHeight
        : 0
      this.headerGroupHeight = Math.max(70, this.headerGroupHeight) + "px"
    }
    this.headerFixed.forEach((fixedElement) => {
      fixedElement.classList.add("fixed")
    })
    document.documentElement.style.setProperty(
      "--announsment-height",
      this.announcementBarHeight
    )
    document.documentElement.style.setProperty(
      "--announsment-height-negativ",
      "-" + this.announcementBarHeight
    )
    document.documentElement.style.setProperty(
      "--header-height",
      this.headerGroupHeight
    )
  },
  calculateHeaderWidth() {
    this.mainContainerWidth = this.mainContainer
    if (this.announcementBar) {
      this.announcementBar.style.width =
        this.mainContainerWidth.offsetWidth + "px"
    }

    this.headerGroup.style.width = this.mainContainerWidth.offsetWidth + "px"
    this.megaMenuOverlay.style.width =
      this.mainContainerWidth.offsetWidth + "px"
    this.menuInner.forEach((element) => {
      element.style.width = this.mainContainerWidth.offsetWidth + "px"
    })
  },
  preventBodyScroll() {
    document.querySelector("body").style.overflow = "scroll"
    document.querySelector("html").style.overflow = "hidden"
    document.querySelector("html").style.maxHeight = "100vh"
  },
  allowBodyScroll() {
    document.querySelector("body").style.overflow = ""
    document.querySelector("html").style.overflow = ""
    document.querySelector("html").style.maxHeight = ""
  },
  openMegaMenu(event, handle) {
    if (this.suppressMenuOpen) return
    this.preventBodyScroll()
    if (window.innerWidth >= 991) {
      if (handle) {
        const navigationItems = document.querySelectorAll(
          ".main-navigation__item"
        )

        if (navigationItems) {
          navigationItems.forEach((item) => {
            item.classList.remove("mega-menu-open")
          })
        }

        const itemEl = this.getNavItemEl(event)
        this.selectedItem = itemEl
        const selectedItem = itemEl.querySelector(".main-navigation__item")
        if (selectedItem) {
          selectedItem.classList.add("mega-menu-open")
          this.lastMenuTrigger = selectedItem
        }
        const submenu = itemEl.querySelector(`[data-submenu]`)
        if (submenu) {
          this.selectedHandle = submenu.getAttribute("data-handle")
          this.showMegaMenu = true
        }
      } else {
        this.showMegaMenu = false
        this.selectedHandle = null
        this.allowBodyScroll()
      }
      this.selectActiveNavigationItem(event)
    }
  },
  closeMegaMenu(event) {
    if (window.innerWidth >= 991) {
      const navigationItems = document.querySelectorAll(
        ".main-navigation__item"
      )

      if (navigationItems) {
        navigationItems.forEach((item) => {
          item.classList.remove("mega-menu-open")
        })
      }
      this.showMegaMenu = false
      this.selectedHandle = null
      this.allowBodyScroll()
      if (event) this.selectActiveNavigationItem(event)
      else this.resetNavigationItemsStyles()
    }
  },
  openSimpleMenu(event, handle) {
    if (this.suppressMenuOpen) return
    this.preventBodyScroll()
    const itemEl = this.getNavItemEl(event)
    const simpleMenu = itemEl.querySelector(`[data-simple-menu]`)
    if (!simpleMenu) return

    this.selectedHandle = simpleMenu.getAttribute("data-simple-menu-handle")
    this.showMegaMenu = true
    const navigationItems = document.querySelectorAll(".main-navigation__item")

    if (navigationItems) {
      navigationItems.forEach((item) => {
        item.classList.remove("mega-menu-open")
      })
    }
    this.selectedItem = itemEl
    const selectedItem = itemEl.querySelector(".main-navigation__item")
    if (selectedItem) {
      selectedItem.classList.add("mega-menu-open")
      this.lastMenuTrigger = selectedItem
    }
    this.selectActiveNavigationItem(event)
  },
  openMobileMenu() {
    window.dispatchEvent(new CustomEvent("close-search"))
    this._mobileMenuOpener = document.activeElement
    this.showMobileMenu = true
    this.preventBodyScroll()
    if (this.announcementBar) {
      if (
        getComputedStyle(document.querySelector(".announcement-bar"))
          .transform === "matrix(1, 0, 0, 1, 0, 0)"
      ) {
        document.querySelector(".mobile-menu__wrapper").style.height =
          "calc(" + window.visualViewport.height + "px - 2rem)"
      } else {
        document.querySelector(".mobile-menu__wrapper").style.height = "100dvh"
      }
    }
  },
  closeMobileMenu() {
    this.showMobileMenu = false
    this.closeSubmenu()
    this.allowBodyScroll()
    const opener = this._mobileMenuOpener
    this._mobileMenuOpener = null
    if (opener && typeof opener.focus === 'function') {
      queueMicrotask(() => opener.focus())
    }
  },
  openMobileCurrencyDrawer() {
    this.showMobileMenu = false
    this.closeSubmenu()
    // The opener lives inside the mobile menu we just closed, so fall back to
    // the menu trigger to avoid returning focus to an off-screen element.
    this._mobileCurrencyOpener =
      document.querySelector("[data-mobile-menu-trigger]") ||
      document.activeElement
    this.showMobileCurrencyDrawer = true
    this.preventBodyScroll()
  },
  closeMobileCurrencyDrawer() {
    this.showMobileCurrencyDrawer = false
    this.allowBodyScroll()
    const opener = this._mobileCurrencyOpener
    this._mobileCurrencyOpener = null
    if (opener && typeof opener.focus === 'function') {
      queueMicrotask(() => opener.focus())
    }
  },
  openSubmenu(event, handle) {
    this.showSubMenu = true
    this.selectedMobileHandle =
      event.target.getAttribute("data-handle") ||
      event.currentTarget.closest("a").getAttribute("data-handle")
  },
  openThirdSubmenu(event, handle) {
    this.showThirdLevelSubMenu = true
    this.selectedThirdLevelMobileHandle =
      event.target.getAttribute("data-handle") ||
      event.currentTarget.closest("a").getAttribute("data-handle")
  },
  closeSubmenu() {
    this.showSubMenu = false
  },
  closeThirdSubmenu() {
    this.showThirdLevelSubMenu = false
  },
  selectActiveNavigationItem(event) {
    const itemEl = event ? event.currentTarget || event.target : null
    if (!itemEl || typeof itemEl.getAttribute !== "function") {
      this.resetNavigationItemsStyles()
      return
    }

    const selectedItemHeading = itemEl.getAttribute("data-item-heading")
    this.navigationItems.forEach((item) => {
      item.style.opacity = "100%"
      item.classList.remove("inactive")
      const itemHeading = item.getAttribute("data-item-heading")

      if (itemHeading !== selectedItemHeading) {
        item.classList.add("inactive")
        // item.style.opacity = "60%"
      }
    })
  },
  resetNavigationItemsStyles() {
    this.navigationItems.forEach((item) => {
      item.classList.remove("inactive")
      item.style.opacity = "100%"
    })
  },
})

export default navigation

document.addEventListener("alpine:init", () => {
  Alpine.data("navigation", navigation)
})
